import { Box, Typography } from '@material-ui/core/';
import React from 'react';

export const VersionToggle = ({
  showLabels = true,
  compact = false,
  showTooltip = true,
}) => {

  const getTargetUrl = () => {
    return "";
  };

  const getLinkText = () => {
    return 'SWITCH TO NEW DIT'; 
  };
  
  const handleOpenOldDIT = (e) => {
    e.preventDefault();
    const url = "https://partnerportal.bajajamc.com";
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      component='a'
      href={getTargetUrl()}
      sx={{
        'display': 'flex',
        'height': '38px', 
        'alignItems': 'center',
        'justifyContent': 'center',
        'px': 4, 
        'borderRadius': '50px', 
        'background': `#005dac`, 
        'color': '#ffffff', 
        'boxShadow': '0px 4px 12px rgba(26, 35, 126, 0.4)', 
        'border': 'none',
        'cursor': 'pointer',
        'transition': 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)', 
        'textDecoration': 'none',
        '&:hover': {
          background: `#005dac`, 
          boxShadow: '0px 6px 16px rgba(26, 35, 126, 0.6)', 
          transform: 'translateY(-3px)', 
          textDecoration: 'none',
          color: '#ffffff', 

        },
        '&:active': {
          transform: 'translateY(0) scale(0.96)', 
          boxShadow: '0px 2px 6px rgba(26, 35, 126, 0.4)',
          color: '#ffffff', 

        },
        '&:focus-visible': {
          outline: '3px solid #9fa8da', 
          outlineOffset: 3,
        },
      }}
      onClick={handleOpenOldDIT}
    >
      <Typography
        variant='caption'
        sx={{
          color: "#ffffff", 
          fontWeight: 900,
          fontSize: '17px',
          whiteSpace: 'nowrap',
          textTransform: 'uppercase',
          letterSpacing: '1px', 
        }}
      >
        {getLinkText()}
      </Typography>
    </Box>
  );
};

export default VersionToggle;
